import { createIcon, IconColors } from './icon-utils';

export const ErrorIcon = createIcon({
  fill: IconColors.Red,
  path: 'M12 15.75c.621 0 1.125.504 1.125 1.125S12.621 18 12 18s-1.125-.504-1.125-1.125.503-1.125 1.125-1.125zm.75-2.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75V5.25c0-.414.336-.75.75-.75s.75.336.75.75v8.25zM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-1.5c5.799 0 10.5-4.701 10.5-10.5S17.799 1.5 12 1.5 1.5 6.201 1.5 12 6.201 22.5 12 22.5z',
});
